export default __webpack_public_path__ + "static/2-375437ed97cdafd06d55af857c8bd499.png";